/**
 * CLE-2266 — case-signature display rules for the claim modal.
 *
 * The 835 (adjudicated) signature is always shown. The 837 (billed) signature is only
 * meaningful to surface when it actually differs from the 835 one — that delta IS the
 * billed-vs-adjudicated code change (e.g. a CPT/E-M downgrade). When the 837 signature is
 * absent or identical to the 835 one, the row is redundant noise and is omitted.
 */
export const shouldShow837CaseSignature = (
  caseSignature: string | null | undefined,
  edi837CaseSignature: string | null | undefined
): boolean => !!edi837CaseSignature && edi837CaseSignature !== caseSignature;
